
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      toggledNav: false,
    }
  },
  computed: {
    ...mapGetters({
      favorites_list: 'favorites_list',
    }),
    favorites: {
      get() {
        return this.favorites_list ? this.favorites_list : null
      },
      set(value) {
        this.setFavorites(value)
      },
    },
  },
  watch: {
    $route() {
      this.toggledNav = false
    },
  },
  created() {
    this.$store.dispatch('setFavorites')
  },
  methods: {
    deleteFavorite(favorite) {
      this.$favoriteService.delete(favorite.id).then(() => {
        setTimeout(() => {
          this.$store.dispatch('setFavorites')
        }, 200)
      })
    },
  },
}
